<div class="activity-box-wrapper" (click)="!isFull && !isSelected && onSelectActivity()">
	<div class="chip" *ngIf="isFull">
		<app-sp-chip [text]="'Full'"></app-sp-chip>
	</div>
	<div class="activity-box" [ngClass]="{ full: isFull, selected: isSelected }">
		<div class="activity-name">{{ activity.name }}</div>

		<div *ngIf="activity.description" class="activity-description">{{ activity.description }}</div>
		<div class="activity-tags">
			<div class="tw-flex tw-items-center activity-teacher" *ngIf="locationsMap$ | async as locationsMap">
				<div
					class="tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-mr-1"
					[style.background]="locationsMap[activity.location_id]?.color_profile?.solid_color">
					<img class="tw-w-2.5 tw-h-2.5" [src]="locationsMap[activity.location_id]?.icon | resolveAsset" />
				</div>
				{{ locationsMap[activity.location_id]?.title }}
			</div>
			<div *ngIf="activity.managers.length == 0" class="activity-teacher">
				<img
					*ngIf="activity.profile_picture"
					src="{{ activity.profile_picture }}"
					class="teacher-photo"
					alt="photo of {{ activity.teacher_name }}" />{{ activity.teacher_name }}
			</div>

			<div *ngFor="let teacher of activity.managers" class="activity-teacher">
				<img *ngIf="teacher.profile_picture" src="{{ teacher.profile_picture }}" class="teacher-photo" alt="photo of {{ teacher.display_name }}" />
				{{ teacher.display_name }}
			</div>
		</div>

		<div class="activity-capacity">{{ studentCapacity }}</div>
	</div>
</div>
